import { useMemo, useState } from 'react';
import './TransporterModal.scss';

const TransporterModal = ({ visible, onClose, transporters = [] }) => {
    const [search, setSearch] = useState('');

    const filtered = useMemo(() =>
        transporters.filter(t =>
            t.transporter_name.toLowerCase().includes(search.toLowerCase())
        ),
        [transporters, search]
    );

    if (!visible) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <button className="modal-close" onClick={onClose}>×</button>

                <h3>Transporters and Price</h3>

                <input
                    type="text"
                    placeholder="Search Transporters..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="search-input"
                />

                <table className="modal-table">
                    <thead>
                        <tr>
                            <th>Sl No</th>
                            <th>Transporters</th>
                            <th>Price</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filtered.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.transporter_name}</td>
                                <td>₹ {item.price.toLocaleString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="modal-footer">
                    <button className="close-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default TransporterModal;
